import actionTypes from '../actions/actionsFactory/types';
import { bigNumberPlus, formatBigNumber } from '../utils/number';

export const INITIAL_STATE = {
  marginStatus: false,
  marginAccount: {
    userAssets: [], marginLevel: '3.00', marginFreeAssets: {}, totalAssetOfBtc: '0',
  },
  marginCoeff: {},
  marginAssets: [],
  marginSymbols: {},
  marginSymbolsFlat: [],
  isMarginPair: true,
  marginForceUpdate: 0,
};

const formatRisk = risk => {
  // eslint-disable-next-line prefer-const
  let [a, b = ''] = `${risk}`.split('.');
  b += '00';
  return `${a}.${b.substr(0, 2)}`;
};

const hanldeSymbols = (symbols = []) => symbols.reduce((pre, cur) => {
  pre[cur.base] ? pre[cur.base].push(cur) : pre[cur.base] = [cur];
  return pre;
}, {});

const handleMarginAccount = ({ userAssets = [], marginLevel, ...rest }) => {
  const marginFreeAssets = {};
  const newAssetArr = [];
  const debtMap = {};
  userAssets.forEach(({
    free, locked, asset, borrowed, interest, netAsset, netAssetOfBtc,
  }) => {
    marginFreeAssets[asset] = free;
    const debt = bigNumberPlus(borrowed, interest);
    debtMap[asset] = debt;
    newAssetArr.push({
      free,
      asset,
      locked,
      borrowed,
      interest,
      netAsset,
      netAssetOfBtc,
      totalDebt: debt,
      totalAmount: bigNumberPlus(free, locked),
      _netAsset: formatBigNumber(netAsset, 4),
      _netAssetOfBTC: formatBigNumber(netAssetOfBtc, 4),
    });
  });
  return {
    ...rest,
    marginLevel: formatRisk(`${marginLevel}`),
    marginFreeAssets,
    debtMap,
    userAssets: newAssetArr,
  };
};

export const reducer = (state, { type, data }) => {
  switch (type) {
    case actionTypes.SET_MARGIN_STATUS:
      return {
        ...state,
        marginStatus: data,
      };
    case actionTypes.SET_MARGIN_ACCOUNT:
      return {
        ...state,
        marginAccount: handleMarginAccount(data),
      };
    case actionTypes.SET_MARGIN_ASSETS:
      return {
        ...state,
        marginAssets: data,
      };
    case actionTypes.SET_MARGIN_FORCE_UPDATE:
      return {
        ...state,
        marginForceUpdate: Math.random(),
      };
    case actionTypes.SET_MARGIN_COEFF:
      return {
        ...state,
        marginCoeff: data,
      };
    case actionTypes.SET_MARGIN_SYMBOLS:
      return {
        ...state,
        marginSymbols: hanldeSymbols(data),
        marginSymbolsFlat: data,
      };
    case actionTypes.SET_IS_MARGIN_PAIR:
      return {
        ...state,
        isMarginPair: data,
      };
    default:
      return state;
  }
};
